import React from 'react';
import { Container } from '@mui/material';
import { EventWrapper, IEventWrapper } from '../../EventComponents/EventWrapper';

interface IEventContainerProps extends IEventWrapper {}

const EventContainer: React.FC<IEventContainerProps> = props => {
    return (
        <Container
            disableGutters
            style={{
                height: 'auto',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                // overflow: 'hidden',
            }}
            sx={{
                width: '100%',
                marginTop: { xs: '0', sm: '20px', md: '20px', lg: 0 },
                marginLeft: { xs: '0px', sm: '20px' },
                paddingLeft: { xs: '0', md: '10px' },
                paddingRight: { xs: '0', md: 0 },
                overflowX: 'hidden',
            }}>
            <EventWrapper {...props} />
        </Container>
    );
};

export { EventContainer };
